import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { Box } from "@mui/material";
import { Button, brand, Typography } from "@platform/design-system";
import { JSX } from "react";

interface Props {
  error: string | Error;
  onClick: VoidFunction;
}

// Mounted as the root ErrorBoundary's fallback, above the app's ThemeProvider,
// so the theme in scope here is MUI's default. `brand()` falls back to the
// token values when the theme has no `brand` palette.
const FullPageError = ({ error, onClick }: Props): JSX.Element => (
  <Box
    textAlign="center"
    height="calc(100vh - 100px)"
    mt={8}
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <ReportGmailerrorredIcon sx={{ fontSize: 64, color: brand("primary") }} />
    <Typography mb={2} mt={3} variant="display-small">
      {error instanceof Error ? error.message : error}
    </Typography>
    <Button onClick={onClick} variant="primary">
      Try again
    </Button>
    <Typography variant="body-medium" display="block" mt={3}>
      If the problem persists, please email us at{" "}
      <Typography variant="body-medium" component="span" color="brandPrimary">
        <strong>help@centrobenefits.com</strong>
      </Typography>
    </Typography>
  </Box>
);

export default FullPageError;
